// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hint_container__3Ea7R {
  position: relative;
  max-width: fit-content;
}

.hint_inlineContainer__9hW1B {
  position: static;
  display: inline-flex;
  flex-direction: row-reverse;
  gap: 4px;
  align-items: center;
  max-width: none;
}

.hint_hint__55L3i {
  font-weight: bold;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.hint_topRight__D-JiW {
  left: 99%;
  bottom: 99%;
}

.hint_topLeft__PlVqA {
  right: 99%;
  bottom: 99%;
}

.hint_bottomLeft__33os\\+ {
  right: 99%;
  top: 99%;
}

.hint_bottomRight__t0Lrq {
  left: 99%;
  top: 99%;
}`, "",{"version":3,"sources":["webpack://./src/components/Hint/hint.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EAEE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAGA,YAAA;AAFF;;AAKA;EACE,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,UAAA;EACA,WAAA;AAFF;;AAKA;EACE,UAAA;EACA,QAAA;AAFF;;AAKA;EACE,SAAA;EACA,QAAA;AAFF","sourcesContent":[".container {\n  position: relative;\n  max-width: fit-content;\n}\n\n.inlineContainer {\n  position: static;\n  display: inline-flex;\n  flex-direction: row-reverse;\n  gap: 4px;\n  align-items: center;\n  max-width: none;\n}\n\n.hint {\n  //position: absolute;\n  font-weight: bold;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  //border-radius: 50px;\n  //border: black 2px solid;\n  z-index: 999;\n}\n\n.topRight {\n  left: 99%;\n  bottom: 99%;\n}\n\n.topLeft {\n  right: 99%;\n  bottom: 99%;\n}\n\n.bottomLeft {\n  right: 99%;\n  top: 99%;\n}\n\n.bottomRight {\n  left: 99%;\n  top: 99%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hint_container__3Ea7R`,
	"inlineContainer": `hint_inlineContainer__9hW1B`,
	"hint": `hint_hint__55L3i`,
	"topRight": `hint_topRight__D-JiW`,
	"topLeft": `hint_topLeft__PlVqA`,
	"bottomLeft": `hint_bottomLeft__33os+`,
	"bottomRight": `hint_bottomRight__t0Lrq`
};
export default ___CSS_LOADER_EXPORT___;
